import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { FC } from 'react';

import { SubscriptionsHelp } from '../subscriptions-help';

export const SubscriptionsHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-center mb-4">
      <Typography variant="h300" element="h1">
        {t('SUBSCRIPTIONS.TITLE')}
      </Typography>

      <SubscriptionsHelp />
    </div>
  );
};
